import React, { useEffect } from "react";
import "./styles.less";

import { DocBlock } from "../components/DocBlock";
import { DocCode } from "../components/DocCode";
import { DocImg } from "../components/DocImg";

export const B2bPlayground = () => {
  useEffect(() => {
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: ".m2b-toc",
      // Where to grab the headings to build the table of contents.
      contentSelector: ".m2b-toc-content",
      // Which headings to grab inside of the contentSelector element.
      headingSelector: "h1, h2, h3",
      // For headings inside relative or absolute positioned containers within content.
      hasInnerContainers: true,
      positionFixedSelector: ".m2b-toc",
      linkClass: "toc-link",
    });
  }, []);
  return (
    <div className="m2b-plauground-warp">
      <div className="m2b-plauground-inner">
        <div className="m2b-toc-content toc-content-left">
          <DocBlock title="项目简介" keyId="m2b-1">
            <div className="descript">
              <p>
                周报系统的技术栈主要是
                node+vue+redis+mysql+es6，一个企业管理系统，企业员工汇报每周工作情况，以及完成情况，各级负责人可以查看和提醒相应未写周报人员，后端完全使用
                nodeJS，数据库使用 mysql，基于 nodejs 的 thinkjs 框架搭建的
              </p>
              <p>引用的开源项目地址：</p>
              <p>
                Github：
                <a
                  href="https://github.com/Authing/Playground-ToB"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://github.com/Authing/Playground-ToB
                </a>
              </p>
              <p>
                项目前后端分离，前端采用 Vue + javascript,后端采用
                nodejs+thinkjs .
              </p>
              <p>
                项目说明文档中已经详细的阐述了如何部署到本地，此处仅补充说明:
              </p>
              <p>
                项目仅作示例展示用，接下来将具体介绍如何接入 Authing
                服务，有多种方式，本文侧重点在于介绍通过不改变原本项目前端
                UI，而在后端「调用 SDK 」的方式。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="预备知识" keyId="m2b-2">
            <div className="descript">
              <p>
                如果你还没有用过
                Authing，可以点击这里查看如何创建一个自己的应用。
              </p>
              <p>
                对 Authing 的任何名词/概念有疑问：
                <a href="https://docs.authing.co/v2/concepts/">
                  https://docs.authing.co/v2/concepts/
                </a>
              </p>
              <p>
                接下来，假设你已经对 Authing 有初步了解，且在 Authing
                控制台创建了一个自己的应用。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="全局配置" keyId="m2b-3">
            <div className="descript">
              <DocCode
                title="首先要在项目中引入 Authing 提供的 SDK 依赖："
                code={`npm install authing-js-sdk `}
              />
              <p>
                引入 Authing 提供的 SDK 之后，要获取Authing 服务最核心的
                <b>认证侧类 AuthenticationClient</b> 和
                <b>管理侧类 ManagementClient，</b>
                通过调用这两个类中封装好的方法，就可以使用 Authing 提供的服务。
              </p>

              <p>新建应用：</p>
              <p>
                在 Authing 控制台新建应用。这里我们新建了一个类型为 标准 web
                应用的新应用。名称为 playground-weekly。 并且修改应用的登录回调
                URL 为：http://localhost:8082/authinglogin?
              </p>
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2b-01.png" />
              <p>新建用户：</p>
              <DocImg
                title="在用户管理 - 用户列表里，点击创建用户按钮，在弹出的创建用户框内输入新的用户名和密码。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-02.png"
              />
              <p>点击确定完成新用户的创建。</p>
              <DocImg
                title="在权限管理界面，选中权限分组中的 playground-weekly 分组。点击角色管理 tab 页面。点击创建角色按钮，在弹出的创建角色弹窗中输入如下内容："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-03.png"
              />
              <p>点击确定，完成角色的创建。</p>
              <DocImg
                title="进入用户管理 - 角色列表，点击进入 admin 用户的详情信息页面。点击角色权限tab 页。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-04.png"
              />
              <DocImg
                title="点击添加角色按钮。在弹出的窗口中选择："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-05.png"
              />
              <p>点击保存按钮，即可为 admin 账号赋予 系统管理员 的角色。</p>
              <p>前端项目配置：</p>
              <DocCode
                title="在 weekli-web 的 src 目录下新建文件夹 authing，并且在 authing 文件夹内新建文件 index.js 。index.js 的文件内容如下："
                code={`import {AuthenticationClient} from 'authing-js-sdk'

                export const authingClient=new AuthenticationClient({
                    appId:'AUTHING_APPID',
                    secret:'AUTHING_APPSECRET',
                    appHost:'AUTHING_APPHOST',
                    redirectUri:'AUTHING_REDIRECTURI'
                });
                export const appId="";
                export var tenantId='';
                export function setTenantId(value){
                  tenantId=value;
                }`}
              />
              <p>后端项目配置：</p>
              <DocCode
                title="在 weekli-node 的 src /common 目录下新建文件夹 authing，并且在 authing 文件夹内新建文件 index.js。index.js 的文件内容如下："
                code={`import { ManagementClient } from 'authing-js-sdk';

                const managementClient=new ManagementClient({
                    userPoolId:'AUTHING_USERPOOLID',
                    secret:'AUTHING_SECRET'
                });
                
                const authenticationClient=new AuthenticationClient({
                    appId:''
                });
                
                module.exports=managementClient;`}
              />
              <p>如果你不知道如何获取这些数据：</p>
              <p>
                App ID、App Secret、APP Host：
                <a href="https://docs.dev.authing-inc.co/v2/guides/faqs/get-app-id-and-secret.html">
                  https://docs.dev.authing-inc.co/v2/guides/faqs/get-app-id-and-secret.html
                </a>
              </p>
              <p>
                用户池 ID、用户池 Secret：
                <a href="https://docs.authing.co/v2/guides/faqs/get-userpool-id-and-secret.html">
                  https://docs.authing.co/v2/guides/faqs/get-userpool-id-and-secret.html
                </a>
              </p>
              <p>多租户配置：</p>
              <p>在 Authing 控制台新建多租户</p>
              <p>租户名称：企业 A</p>
              <p>关联应用选择新建的 playground-weekly</p>
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2b-06.png" />
              <p>点击创建按钮，完成租户的创建。</p>
              <DocImg
                title="进入租户的配置界面，在租户成员 tab 页选择添加成员，选择在前面创建的用户 admin"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-07.png"
              />
              <DocImg
                title="点击确定，将此用户加入到租户 企业A 的租户成员中。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-08.png"
              />
              <p>
                在完成租户成员的添加后，点击操作按钮，设置 admin 为租户管理员。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="登录/注册" keyId="m2b-4">
            <DocImg
              title="备注：登出接口有问题，暂时不能登出"
              src="//files.authing.co/authing-website/doc-img/playground-b2b-09.png"
            />
          </DocBlock>
          <DocBlock title="部门管理" keyId="m2b-5">
            <div className="descript">
              <DocImg
                title="通过租户管理员账号登录企业 A 后，将进入到周报系统的管理员界面。我们可以在此页面对企业的部门进行管理。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-10.png"
              />
              <DocImg
                title="在管理员管理 tab 页里，选择管理公司，进入公司管理页面。点击添加公司，即可完成组织机构下的部门添加。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-11.png"
              />

              <DocCode
                title="添加公司的后台相关逻辑如下："
                code={` if (userInfo.role == 1) {
                  if (formUser.type == "add") {
                    var org = await managementClient.org.getOrgByTenantId(tenantId);
          
                    var result = await managementClient.org.addNode(
                      org[0].orgId,
                      org[0].id,
                      { name: formUser.company_name }
                    );
          
                    return this.success("添加成功");
                  } else if (formUser.type == "edit") {
                    var result = await managementClient.org.updateNode(
                      formUser.company_id,
                      { name: formUser.company_name }
                    );
          
                    return this.success("编辑成功");
                  }
                } else {
                  return this.fail("你没有权限");
                }`}
              />
              <DocImg
                title="完成添加公司后的列表如下图所示："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-12.png"
              />
              <DocImg
                title="接下来在公司管理菜单项，点击管理部门，进入部门管理页面："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-13.png"
              />
              <DocImg
                title="点击添加部门，完成部门的添加："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-14.png"
              />
              <DocImg
                title="完成部门添加后的部门列表如下："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-15.png"
              />
              <DocCode
                title="添加部门的相关逻辑如下："
                code={` try {
      let {
        department_id,
        department_name,
        type,
        id,
        company_id,
        company_name,
        org_id,
      } = this.post();

      if (type == "add") {
        var result = await managementClient.org.addNode(org_id, company_id, {
          name: department_name,
        });
        return this.success("添加成功");
      } else if (type == "edit") {
        var result = await managementClient.org.updateNode(department_id, {
          name: department_name,
        });
        return this.success("修改成功");
      }
    } catch (e) {
      return this.fail(e);
    }`}
              />
            </div>
          </DocBlock>
          <DocBlock title="人员管理" keyId="m2b-6">
            <div className="descript">
              <DocImg
                title="对部门完成添加后，可以进入部门管理的成员管理页面，对公司的人员进行相关的管理。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-16.png"
              />
              <DocImg
                title="点击添加成员，输入人员的相关信息："
                src="//files.authing.co/authing-website/doc-img/playground-b2b-17.png"
              />

              <DocCode
                title="添加用户的相关后台逻辑如下："
                code={` try {
                  if (type == "add" || type == "companyAdminAdd") {
                    let addUserResult = await managementClient.users.create({
                      name: username,
                      email,
                      phone: telephone,
                    });
                    var setUDF = await managementClient.users.setUdfValue(
                      addUserResult.id,
                      { usernum }
                    );
                    //设置角色
                    var addRole = await managementClient.roles.addUsers(
                      role,
                      [addUserResult.id],
                      app_id
                    );
            
                    //添加到部门
                    var addDep = await managementClient.org.addMembers(department_id, [
                      addUserResult.id,
                    ]);
            
                    return this.success("添加成功");
                  } else if (type == "edit" || type == "companyAdminEdit") {
                    let updateUser = await managementClient.users.update(id, {
                      email,
                      phone: telephone,
                      name:username
                    });`}
              />

              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2b-18.png" />
            </div>
          </DocBlock>
          <DocBlock title="角色管理" keyId="m2b-7">
            <div className="descript">
              <DocImg
                title="可以通过接入 Authing 的权限管理功能，对用户分配相关的角色。进入管理员管理 - 角色管理页面。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-19.png"
              />

              <DocImg
                title="点击添加角色角色，输入角色 code 和描述。"
                src="//files.authing.co/authing-website/doc-img/playground-b2b-20.png"
              />

              <DocCode
                title="添加角色的后台相关逻辑如下："
                code={`async addRoleAction(){
    try{
      let {oldCode,code,description,app_id,type,namespace}=this.post();

      if(type=="add"){
        var addRole=await managementClient.roles.create(code,description,app_id);
        return this.success(addRole);
      }else if(type="edit"){
        var editRole=await managementClient.roles.update(oldCode,{namespace,description,newCode:code});
        return this.success(editRole);
      }
     
    }catch(e){
      return this.fail(e.message);
    }
  }`}
              />
              <DocCode
                title="]删除角色的后台相关逻辑如下："
                code={` /**
                * 删除角色
                * @returns 删除角色结果
                */
               async deleteRoleAction(){
                 try{
                   let {code,namespace}=this.post();
             
                   var deleteRole=await managementClient.roles.delete(code,namespace);
                   return this.success(deleteRole);
                 }catch(e){
                   return this.fail(e.message);
                 }
               }`}
              />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2b-21.png" />
            </div>
          </DocBlock>
        </div>
        <div className="toc-rigth">
          <div className="m2b-toc"></div>
        </div>
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  );
};
